import IntendedMajorContainer from "./IntendedMajor";
export { IntendedMajorContainer };
